// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b0e5204f","256":"96a54f31","276":"d5ee57ce","413":"03798656","640":"6db1a323","720":"a7c5d33c","919":"a7208880","989":"c9d28c63"}[chunkId] + ".chunk.js";
};